import { createStart } from "@tanstack/react-start";
import { requestGuard } from "./middleware";
import { initI18n } from "./lib/i18n";

await initI18n();

export const startInstance = createStart(() => ({
  requestMiddleware: [requestGuard],
}));
